import { render, staticRenderFns } from "./InventoryWarehouse.vue?vue&type=template&id=37749675&scoped=true"
import script from "./InventoryWarehouse.vue?vue&type=script&lang=js"
export * from "./InventoryWarehouse.vue?vue&type=script&lang=js"
import style0 from "./InventoryWarehouse.vue?vue&type=style&index=0&id=37749675&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37749675",
  null
  
)

export default component.exports